import useScreenShotRepository from "../../../../../../repository/visio-plus/useScreenShotRepository";
import useOrderRepository from "../../../../../../repository/emergency/useOrderRepository";
import {useEffect} from "react";
import isNull from "../../../../../../mixin/isNull";
import SlideFile from "../../../../../../material/file/SlideFileCustom";
import FileData from "../../../../../../material/file/FileData";
import Accordion from "../../../../../../material/accordion/Accordion";
import AccordionConfig from "../../../../../../material/accordion/AccordionConfig";
import AccordionUnity from "../../../../../../material/accordion/AccordionUnity";

export default function ({orderId}) {
    const orderRepository = useOrderRepository();
    const screenShotRepository = useScreenShotRepository();
    /** @type Order */
    const order = orderRepository.findOneById(orderId).select();
    /** @type ScreenShot[] */
    const screenShots = screenShotRepository.findAllByDiagnosticId(order?.getVisioPlusDiagnosticId()).select();

    useEffect(() => {
        orderRepository.findOneById(orderId).exec();
    }, []);

    useEffect(() => {
        if (isNull(order) || isNull(order.getVisioPlusDiagnosticId())) return;

        screenShotRepository.findAllByDiagnosticId(order.getVisioPlusDiagnosticId()).exec();
    }, [JSON.stringify(order)]);

    const getFile = async id => {
        const data = await screenShotRepository.getFile(id);

        return new FileData(data.name, data.base64, data.content_type);
    }

    if (isNull(screenShots) || screenShots.length === 0) return null;

    return (
        <Accordion
            accordionConfig={
                new AccordionConfig()
                    .setOpenFirstByDefault(false)
                    .addAccordionUnity(
                        new AccordionUnity()
                            .setTitle("Photos prédiagnostic")
                            .setComponent(<SlideFile ids={screenShots.map(ss => ss.getId())} getFile={getFile}
                                                     disableDownload={true}/>)
                    )
            }
        />
    )
}